import { setNodes } from 'slate';

import { generateUUID } from 'utils/general';

// Ensure every node in a table has a unique id so that
// styles can be applied properly.
export const withNormalizeTableNodeIds = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    if (editor.isBlock(node) && node.type === 'table') {
      const { children: rows, id: tableId } = node;

      if (!tableId) {
        setNodes(editor, { id: generateUUID() }, { at: path });
      }

      if (rows) {
        rows.forEach((row, rowIndex) => {
          const { children: cols, id: rowId } = row;
          if (!rowId) {
            setNodes(editor, { id: generateUUID() }, { at: [...path, rowIndex] });
          }

          if (cols) {
            cols.forEach((col, colIndex) => {
              const { id: colId } = col;
              if (!colId) {
                setNodes(editor, { id: generateUUID() }, { at: [...path, rowIndex, colIndex] });
              }
            });
          }
        });
      }
    }
    return normalizeNode([node, path]);
  };

  return editor;
};
